export const PLASMIC_CMS_ID = process.env.NEXT_PUBLIC_PLASMIC_CMS_ID || "";
export const PLASMIC_CMS_PUBLIC_TOKEN = process.env.NEXT_PUBLIC_PLASMIC_CMS_PUBLIC_TOKEN || "";

export const PLASMIC_CMS_API_URL = "https://data.plasmic.app/api/v1/cms/databases";
